import { QueryLazyOptions } from '@apollo/react-hooks'
import {
  useBuscaCidadaoListagemDesenvolvimentoInfantilLazyQuery,
  useBuscaCidadaoListagemDiabetesLazyQuery,
  useBuscaCidadaoListagemGeralLazyQuery,
  useBuscaCidadaoListagemGestantePuerperaLazyQuery,
  useBuscaCidadaoListagemHipertensaoLazyQuery,
  useBuscaCidadaoListagemPessoaIdosaLazyQuery,
  useBuscaCidadaoListagemSaudeBucalLazyQuery,
  useBuscaCidadaoListagemTematicaSaudeMulherLazyQuery,
  useOldBuscaCidadaoListagemLazyQuery,
} from 'graphql/hooks.generated'
import {
  AcompanhamentoCondicaoSaudeTematicaEnum,
  BuscaCidadaoListagemDesenvolvimentoInfantilQueryVariables,
  BuscaCidadaoListagemDiabetesQueryVariables,
  BuscaCidadaoListagemGeralQueryVariables,
  BuscaCidadaoListagemGestantePuerperaQueryVariables,
  BuscaCidadaoListagemHipertensaoQueryVariables,
  BuscaCidadaoListagemPessoaIdosaQueryVariables,
  OldBuscaCidadaoListagemQueryVariables,
} from 'graphql/types.generated'

import { BuscaCidadaoQueryResult } from '../model/model-acompanhamentoCondicaoSaudeListaTematica'

type ListaTematicaResultQueryRecord = Record<AcompanhamentoCondicaoSaudeTematicaEnum, UseBuscaCidadaoListagemResult>

type BuscaCidadaoQueryVariables = QueryLazyOptions<
  | BuscaCidadaoListagemGestantePuerperaQueryVariables
  | BuscaCidadaoListagemGeralQueryVariables
  | BuscaCidadaoListagemHipertensaoQueryVariables
  | BuscaCidadaoListagemDiabetesQueryVariables
  | BuscaCidadaoListagemPessoaIdosaQueryVariables
  | BuscaCidadaoListagemDesenvolvimentoInfantilQueryVariables
  | OldBuscaCidadaoListagemQueryVariables
>

interface UseBuscaCidadaoListagemResult {
  cidadaos: BuscaCidadaoQueryResult
  executeQuery: (filtro: BuscaCidadaoQueryVariables) => void
  loading: boolean
}

export function useBuscaCidadaoListagem(
  listaTematica: AcompanhamentoCondicaoSaudeTematicaEnum,
  flag: boolean
): UseBuscaCidadaoListagemResult {
  const [executeQueryGeral, { data: dataGeral, loading: loadingGeral }] = useBuscaCidadaoListagemGeralLazyQuery()

  const [
    executeQueryGestantePuerpera,
    { data: dataGestantePuerpera, loading: loadingGestantePuerpera },
  ] = useBuscaCidadaoListagemGestantePuerperaLazyQuery()

  const [
    executeQueryDiabetes,
    { data: dataDiabetes, loading: loadingDiabetes },
  ] = useBuscaCidadaoListagemDiabetesLazyQuery()

  const [
    executeQueryHipertensao,
    { data: dataHipertensao, loading: loadingHipertensao },
  ] = useBuscaCidadaoListagemHipertensaoLazyQuery()

  const [
    executeQueryPessoaIdosa,
    { data: dataPessoaIdosa, loading: loadingPessoaIdosa },
  ] = useBuscaCidadaoListagemPessoaIdosaLazyQuery()

  const [
    executeQueryDesenvolvimentoInfantil,
    { data: dataDesenvolvimentoInfantil, loading: loadingDesenvolvimentoInfantil },
  ] = useBuscaCidadaoListagemDesenvolvimentoInfantilLazyQuery()

  const [
    executeSaudeMulherQuery,
    { data: dataSaudeMulher, loading: loadingSaudeMulherQuery },
  ] = useBuscaCidadaoListagemTematicaSaudeMulherLazyQuery()

  const [
    executeSaudeBucalQuery,
    { data: dataSaudeBucal, loading: loadingSaudeBucalQuery },
  ] = useBuscaCidadaoListagemSaudeBucalLazyQuery()

  const [executeOldQueryGeral, { data: dataOldQuery, loading: loadingOldQuery }] = useOldBuscaCidadaoListagemLazyQuery()

  if (!flag) {
    return {
      cidadaos: dataOldQuery?.acompanhamentoCondicaoSaude,
      executeQuery: executeOldQueryGeral,
      loading: loadingOldQuery,
    }
  }

  const listaTematicaRecord: ListaTematicaResultQueryRecord = {
    [AcompanhamentoCondicaoSaudeTematicaEnum.GESTANTE_PUERPERA]: {
      cidadaos: dataGestantePuerpera?.acompanhamentoCondicaoSaude,
      executeQuery: executeQueryGestantePuerpera,
      loading: loadingGestantePuerpera,
    },
    [AcompanhamentoCondicaoSaudeTematicaEnum.GERAL]: {
      cidadaos: dataGeral?.acompanhamentoCondicaoSaude,
      executeQuery: executeQueryGeral,
      loading: loadingGeral,
    },
    [AcompanhamentoCondicaoSaudeTematicaEnum.DESENVOLVIMENTO_INFANTIL]: {
      cidadaos: dataDesenvolvimentoInfantil?.acompanhamentoCondicaoSaude,
      executeQuery: executeQueryDesenvolvimentoInfantil,
      loading: loadingDesenvolvimentoInfantil,
    },
    [AcompanhamentoCondicaoSaudeTematicaEnum.DIABETES]: {
      cidadaos: dataDiabetes?.acompanhamentoCondicaoSaude,
      executeQuery: executeQueryDiabetes,
      loading: loadingDiabetes,
    },
    [AcompanhamentoCondicaoSaudeTematicaEnum.HIPERTENSAO_ARTERIAL]: {
      cidadaos: dataHipertensao?.acompanhamentoCondicaoSaude,
      executeQuery: executeQueryHipertensao,
      loading: loadingHipertensao,
    },
    [AcompanhamentoCondicaoSaudeTematicaEnum.PESSOA_IDOSA]: {
      cidadaos: dataPessoaIdosa?.acompanhamentoCondicaoSaude,
      executeQuery: executeQueryPessoaIdosa,
      loading: loadingPessoaIdosa,
    },
    [AcompanhamentoCondicaoSaudeTematicaEnum.SAUDE_MULHER]: {
      cidadaos: dataSaudeMulher?.acompanhamentoCondicaoSaude,
      executeQuery: executeSaudeMulherQuery,
      loading: loadingSaudeMulherQuery,
    },
    [AcompanhamentoCondicaoSaudeTematicaEnum.SAUDE_BUCAL]: {
      cidadaos: dataSaudeBucal?.acompanhamentoCondicaoSaude,
      executeQuery: executeSaudeBucalQuery,
      loading: loadingSaudeBucalQuery,
    },
  }
  return (
    listaTematicaRecord[listaTematica] ?? {
      cidadaos: undefined,
      executeQuery: () => {},
      loading: false,
    }
  )
}
